import { defineStore } from 'pinia'
import type Portal from '@/types/Portal.ts'

export const usePortalStore = defineStore('portalStore', {
    state: () => ({
        portals: new Map<number, Portal>(),
        updateVersion: 0  // Increments on any portal change for efficient watching
    }),
    getters: {
        findPortalById: (state) => (id: number): Portal | undefined => {
            return state.portals.get(id)
        }
    },
    actions: {
        setPortal(portal: Portal) {
            this.portals.set(portal.id, portal)
            this.updateVersion++;
        }
    }
})
